// /src/components/CategoryPile.tsx (改造成通用的 Foundation Pile)

import React from 'react';
import { FoundationPileData } from '../types/game';

interface CategoryPileProps {
  pile: FoundationPileData; 
  mainCategoryId: string; // 例如 "ANIMALS"
  onCardDrop: (draggedWord: string, targetFoundationId: number) => void; 
}

const CategoryPile: React.FC<CategoryPileProps> = ({ 
    pile, 
    mainCategoryId,
    onCardDrop 
}) => {

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const draggedWord = e.dataTransfer.getData("text/plain");
    // 这里只负责传递事件，具体的逻辑检查交给 GameContainer
    onCardDrop(draggedWord, pile.foundationId);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  // 动态显示内容：如果是初始状态，显示占位符；如果有锁定分类，显示父级卡片样式
  const isLocked = !!pile.lockedCategoryId;
  const isCompleted = pile.targetCount && pile.currentCount >= pile.targetCount;
  
  // 如果已经有父级卡片放入，我们渲染一个伪造的卡片样式，而不是半透明背景
  if (isLocked) {
      return (
          <div
            className={`category-pile filled ${isCompleted ? 'completed-anim' : ''}`}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            // 内联样式辅助
            style={{
                color: '#333',
                position: 'relative'
            }}
          >
              {isCompleted && <div className="completion-star">⭐</div>}
              <span style={{position: 'absolute', top: '2px', left: '2px', fontSize: '14px', zIndex: 5}}>👑</span>
              <div className="category-target" style={{ opacity: 1 }}> {/* 强制不透明 */}
                 {/* 移除中间的大皇冠，只保留 category 内容 */}
                 {/* 根据用户反馈：Goal 这里显示的是父级单词牌... 不需要中间的大皇冠 */}
                 {/* 只有当 pile.categoryEmoji 存在时才显示 Emoji (例如水果图标) */}
                 {/* 如果有 image (且不是空字符串) 则显示 image，否则显示 Emoji */}
                 {/* 这里明确渲染 image 或 categoryEmoji 和 categoryWord */}
                 {/* 注意：FoundationPileData 里的 image 字段之前没定义，可能需要扩展，但这里我们先处理 emoji */}
                 {/* 假设 pile 对象里扩展了 categoryImage 字段，或者我们依赖 GameContainer 传进来 */}
                 {/* 由于目前 pile 只有 categoryEmoji，我们先只修复 Emoji 的空值显示问题 */}
                 
                 {typeof pile.categoryEmoji === 'string' && pile.categoryEmoji.trim() !== "" && (
                     <div style={{ fontSize: '30px', lineHeight: '1', marginBottom: '5px' }}>
                        {pile.categoryEmoji}
                     </div>
                 )}
                 <p className="category-word-text" style={{margin: '0', opacity: 1, color: '#333', fontWeight: 'bold'}}>{pile.categoryWord}</p>
              </div>
              <div className="progress" style={{ color: '#666', fontWeight: 'bold' }}>
                {pile.currentCount} / {pile.targetCount !== undefined && pile.targetCount !== null ? pile.targetCount : '?'}
              </div>
          </div>
      );
  }

  // 初始空状态 (Goal Placeholder)
  return (
    <div
      className="category-pile"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    >
      <div className="category-target">
        <span className="watermark-emoji">👑</span>
        <p className="watermark-text">Goal</p>
      </div>
      <div className="progress">
        {pile.currentCount} / {pile.targetCount !== undefined && pile.targetCount !== null ? pile.targetCount : '?'}
      </div>
    </div>
  );
};

export default CategoryPile;
